import React from 'react';
import { ReactComponent as HeartIcon } from '../../../assets/img/heart.svg';

const Footer = () => {
  return (
    <footer className='text-center mt-2 mb-3'>
      <div>
        Made with by 🤖 <HeartIcon className='mx-1' /> on Elrond.
      </div>
    </footer>
  );
};

export default Footer;
